/* filter those items that can be grouped into one by the definition of the table QSellerHomologation */
// eslint-disable-next-line no-unused-vars
export const groupHomolableItems = (items, sellerHomologations, selectedItems = []) => {
  const itemsGrouped = {}
  const clonedItems = JSON.parse(JSON.stringify(items))
  const itemsFiltered = clonedItems.filter(item => {
    const sellerHomologation = sellerHomologations.find(sh => sh.sellerId === item.sellerId)
    // We first validate wether the item need to be grouped or not checking his seller id against sellerHomologations
    if (!sellerHomologation) {
      // if its not needed to group this item we just return the item back to be showed to the user.
      return true
    }
    // We will omit the items that are part of a QMP
    if (item.productId) {
      // if its not needed to group this item we just return the item back to be showed to the user.
      return true
    }

    // We check if the item has been procesed before
    if (!itemsGrouped[item.historyId]) {
      // if no we add a new property to the first item that will store all brother items
      item.homologedItems = item.homologedItems ? item.homologedItems : []
      // Adding a new property to show the seller group
      item.sellerGroupTag = sellerHomologation.groupTag
      itemsGrouped[item.historyId] = item 
    } else {
      // we add the item to homologed items
      // also the homologed items if it exist
      itemsGrouped[item.historyId].homologedItems = itemsGrouped[item.historyId].homologedItems.concat(item.homologedItems && item.homologedItems.length ? [item, ...item.homologedItems] : [item])
      return false
    }
    return true;
  });
  return itemsFiltered;
}